import React, { useEffect, useState } from "react";
import "./Blog.scss";
import DOMPurify from "dompurify";
import axios from "axios";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const Addblog = () => {
  const [blogForm, setBlogForm] = useState({
    title: "",
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    description: "",
    category: "",
    date: "",
  });
  const [imageData, setDataImage] = useState(null);

  const navigate = useNavigate();

  const categoryOptions = [
    "Technology",
    "Lifestyle",
    "SEO",
    "Health",
    "Marketing",
    "Digital",
    "Social",
  ];

  const sanitizeConfig = {
    ALLOWED_TAGS: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "img",
      "p",
      "ul",
      "li",
      "ol",
      "br",
      "iframe",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "style"],
  };

  const sanitizedDescription = DOMPurify.sanitize(
    blogForm.description,
    sanitizeConfig,
  );

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const editBlogs = searchParams.get("id");

  const getBlogById = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PORT_BACKEND}blog/getBybId?bId=${editBlogs}`,
      );

      const data = response.data.data;

      setBlogForm({
        bid: data?.bid,
        date: data?.date,
        category: data?.category,
        title: data?.title,
        description: data?.description,
        metaTitle: data?.metaTitle,
        metaDescription: data?.metaDescription,
        metaKeywords: data?.metaKeywords,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");

    if (id) {
      getBlogById(id);
    }
  }, [location, searchParams]);

  const addBlog = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("featureimage", imageData);
      formData.append("blog", JSON.stringify(blogForm));

      const id = searchParams.get("id");

      let response;
      if (id) {
        response = await axios.put(
          `${process.env.REACT_APP_PORT_BACKEND}blog/updateblog`,
          formData,
        );
        alert("Blog updated successfully!");
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_PORT_BACKEND}blog/addblog`,
          formData,
        );
        alert("Blog added successfully!");
      }

      setBlogForm({
        title: "",
        metaTitle: "",
        metaDescription: "",
        metaKeywords: "",
        description: "",
        category: "",
        date: "",
      });

      setDataImage(null);
      navigate("/bloglist");
      window.location.reload();
    } catch (err) {
      console.log(err);
      alert("Something went wrong, please try again!");
    }
  };


  console.log(blogForm,"blogForm");
  

  return (
    <>
      <div class="add_blog parent">
        <div class="add_blog_form">
          <form action="" onSubmit={addBlog}>
            <div class="form_row">
              <label for=""> Select Date </label>
              <input
                type="date"
                value={blogForm.date}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, date: e.target.value });
                }}
              />
            </div>

            <div className="form_row">
              <label>Select Category</label>
              <select
                className="select"
                value={blogForm.category}
                onChange={(e) =>
                  setBlogForm({ ...blogForm, category: e.target.value })
                }
              >
                <option value="">Select Category</option>
                {categoryOptions.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div class="form_row">
              <label for="">Meta Keywords</label>
              <input
                type="text"
                value={blogForm.metaKeywords}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, metaKeywords: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for="">Meta Title</label>
              <input
                type="text"
                value={blogForm.metaTitle}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, metaTitle: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for="">Meta Description</label>
              <input
                type="text"
                value={blogForm.metaDescription}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, metaDescription: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for=""> Featured Image </label>
              <input
                type="file"
                onChange={(e) => setDataImage(e.target.files[0])}
              />
            </div>

            {/* <div class="form_row">
              <label for="">Blog Slug (url)</label>
              <input
                type="text"
                value={blogForm.blogTitle}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, blogTitle: e.target.value });
                }}
              />
            </div> */}

            <div class="form_row">
              <label for="">Blog Title</label>
              <input
                type="text"
                value={blogForm.title}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, title: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for="">Blog Description</label>
              <div style={{ width: "100%" }}>
                <CKEditor
                  editor={ClassicEditor}
                  data={blogForm.description}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setBlogForm({ ...blogForm, description: data });
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "min-height",
                        "200px",
                        editor.editing.view.document.getRoot(),
                      );
                    });
                  }}
                />
              </div>
            </div>
            {/* <div class="form_row">
              <label>Preview:</label>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizedDescription,
                }}
              />
            </div> */}
            <div class="form_row">
              <input className="btn" type="submit" />
            </div>
          </form>

          <div class="preview">
            <h3>Preview:</h3>

            <p>
              <b>Featured Image:</b>

              {imageData && (
                <div className="preview_img">
                  <img
                    src={URL.createObjectURL(imageData)}
                    alt="preview"
                    style={{ width: "200px", marginBottom: "10px" }}
                  />
                </div>
              )}
            </p>

            <p>
              <b>Date:</b> {blogForm.date}
            </p>
            <p>
              <b>Category:</b> {blogForm.category}
            </p>
            <p>
              <b>Meta Keywords:</b> {blogForm.metaKeywords}
            </p>
            <p>
              <b>Meta Title:</b> {blogForm.metaTitle}
            </p>
            <p>
              <b>Meta Description:</b> {blogForm.metaDescription}
            </p>
            {/* <p>
              <b>Slug:</b> {blogForm.blogTitle}
            </p> */}

            <p>
              <b>Blog Title: </b>
              {blogForm.title}
            </p>
            <p>
              <b>Blog Description: {blogForm.description}</b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addblog;
